// Complete AI Tools Database for Engineering Students
export const toolsDatabase = [
  // Web & App Builders
  {
    id: "loveable",
    name: "Loveable.dev",
    url: "https://loveable.dev",
    shortDescription: "No-code app & web builder using prompts, AI-based",
    supportType: ["coding"],
    category: "web & app builders",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["ai-enthusiast", "prompt-based-user", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["AI-first approach", "Simple prompts", "Fast development", "No-code", "website-building"],
    weaknesses: ["New platform", "Limited control", "AI dependencies"],
    complexity: "beginner"
  },
  {
    id: "bolt-new",
    name: "Bolt.new",
    url: "https://bolt.new",
    shortDescription: "No-code app & web builder using prompts (AI) + manual code edits",
    supportType: ["coding"],
    category: "web & app builders",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["rapid-prototyper", "code-curious", "prompt-based-user"],
    timePressure: "low",
    strengths: ["Fast prototyping", "Full-stack apps", "AI + manual editing", "No-code", "Clean UI", "website-building"],
    weaknesses: ["New platform", "Limited customization", "Deployment limitations"],
    complexity: "beginner"
  },
  {
    id: "glide",
    name: "Glide",
    url: "https://www.glideapps.com",
    shortDescription: "No-code app builder using spreadsheet & prompts, AI-based",
  supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["data-driven-app-builder", "spreadsheet-user", "prompt-based-user"],
    timePressure: "low",
    strengths: ["Spreadsheet-based", "Good templates", "Business-focused", "No-code", "templates", "mobile-app", "Clean UI"],
    weaknesses: ["Limited to certain app types", "Template-dependent"],
    complexity: "beginner"
  },
  {
    id: "softr",
    name: "Softr",
    url: "https://www.softr.io",
    shortDescription: "No-code app builder using prompts, AI-based",
    supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["airtable-user", "portal-creator", "prompt-based-user", "ai-enthusiast", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["Database integration", "Professional templates", "Easy setup", "No-code", "templates"],
    weaknesses: ["Database-dependent", "Limited free tier", "Template-based"],
    complexity: "beginner"
  },
  {
    id: "flutterflow",
    name: "Flutterflow",
    url: "https://flutterflow.io",
    shortDescription: "No-code app builder using prompts (AI) + drag & drop",
     supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["mobile-app-focused", "flutter-interested", "prompt-based-user"],
    timePressure: "medium",
    strengths: ["Flutter-based", "Professional apps", "Good mobile support", "No-code", "mobile-app "],
    weaknesses: ["Learning curve", "Flutter knowledge helpful", "Can be complex"],
    complexity: "intermediate"
  },
  {
    id: "bubble",
    name: "Bubble",
    url: "https://bubble.io",
    shortDescription: "No-code app builder using prompts (AI) + drag & drop",
  supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["systematic-builder", "patient-learner", "self-directed"],
    timePressure: "high",
    strengths: ["Powerful", "Scalable", "Database integration", "Large community", "No-code", "website-building"],
    weaknesses: ["Steep learning curve", "Can be slow", "Expensive for production"],
    complexity: "advanced"
  },
  {
    id: "webflow",
    name: "Webflow",
    url: "https://webflow.com",
    shortDescription: "Visual web design platform with CMS and hosting",
    supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["design-focused", "professional-user", "technical-learner", "web-focused"],
    timePressure: "medium",
    strengths: ["Professional output", "CMS included", "SEO-friendly", "website-building", "Visual design"],
    weaknesses: ["Learning curve", "Expensive for production", "No true backend"],
    complexity: "intermediate"
  },
  {
    id: "framer",
    name: "Framer",
    url: "https://www.framer.com",
    shortDescription: "AI-powered website builder for designers with prototyping features",
    supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["design-focused", "ai-enthusiast", "creative-expresser"],
    timePressure: "low",
    strengths: ["Figma integration", "Responsive design", "Fast optimization", "website-building", "AI generation"],
    weaknesses: ["Design-focused only", "Domain costs extra", "Limited backend"],
    complexity: "beginner"
  },
  {
    id: "adalo",
    name: "Adalo",
    url: "https://www.adalo.com",
    shortDescription: "No-code app builder using prompts, AI-based",
    supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["mobile-app-focused", "simple-app-creator", "prompt-based-user"],
    timePressure: "low",
    strengths: ["Mobile-focused", "Simple interface", "Good for basic apps", "No-code", "mobile-app", "templates", "clean ui"],
    weaknesses: ["Limited functionality", "Mobile-centric", "Performance issues"],
    complexity: "beginner"
  },
  {
    id: "opal",
    name: "Opal (experimental)",
    url: "https://opal.so",
    shortDescription: "No-code app builder using prompts, AI-based",
    supportType: ["coding", "visual"],
    category: "web & app builders",
    aiDependency: "ai-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["experimental", "early-adopter", "ai-enthusiast", "prompt-based-user", "idea-tester"],
    timePressure: "low",
    strengths: ["Experimental features", "AI-first", "No-code"],
    weaknesses: ["Very experimental", "Limited stability", "New platform"],
    complexity: "beginner"
  },
  {
    id: "base44",
    name: "Base44",
    url: "https://base44.com",
    shortDescription: "No-code app and website builder platform using prompts, AI-based",
    supportType: "coding",
    category: "web & app builders",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["multimodal user", "prompt-based-user", "ai-enthusiast", "developer"],
    timePressure: "low",
    strengths: ["Both web and app", "AI-powered", "Multi-platform", "No-code", "website-building", "automation"],
    weaknesses: ["New platform", "Limited track record", "AI dependencies"],
    complexity: "beginner"
  },
  {
    id: "cursor",
    name: "Cursor",
    url: "https://cursor.com",
    shortDescription: "Code editor built on VS Code with intelligent code completion and chat",
    supportType: "coding",
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["code-curious", "technical-learner", "ai-enthusiast", "professional-user", "self-directed"],
    timePressure: "medium",
    strengths: ["VS Code compatibility", "AI code completion", "Multiple AI models", "Agent mode", "Context-aware", "Clean UI"],
    standardizedStrengths: ["debugging", "automation", "good-at-analysis"],
    weaknesses: ["Learning curve for AI features", "Credit-based usage", "Requires coding knowledge"],
    complexity: "intermediate"
  },
  {
    id: "vscode",
    name: "VS Code",
    url: "https://code.visualstudio.com",
    shortDescription: "Free, open-source code editor with extensive extensions and debugging tools",
    supportType: "coding",
    category: "web & app builders",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["code-curious", "technical-learner", "open-source-advocate","developer", "self-directed"],
    timePressure: "medium",
    strengths: ["Extensive extensions", "Cross-platform", "Git integration", "IntelliSense", "debugging",],
    weaknesses: ["Can be resource-heavy", "Requires configuration for some languages", "Extension overload"],
    complexity: "intermediate"
  },

// Visualization & Design Tools
  {
    id: "canva",
    name: "Canva",
    url: "https://www.canva.com",
    shortDescription: "Graphic design with templates, presentations, infographics",
  supportType: ["visual"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["creative-expresser"],
    timePressure: "low",
    strengths: ["Easy templates", "Professional results", "Collaborative", "beautiful-visualizations", "Clean UI", "slides", "infographics"],
    weaknesses: ["Limited free access to add-ons", "Large range of options can be overwhelming"],
    complexity: "beginner"
  },
  {
    id: "genially",
    name: "Genially",
    url: "https://genial.ly",
    shortDescription: "Interactive presentations and infographics",
    supportType: ["visual"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["interactive-designer", "creative-expresser", "educator"],
    timePressure: "medium",
    strengths: ["Interactive elements", "Professional templates", "Animation features", "slides", "infographics"],
    weaknesses: ["Advanced features can get complex", "Limited free tier", "Large range of options can be overwhelming"],
    complexity: "intermediate"
  },
  {
    id: "beautiful-ai",
    name: "Beautiful.ai",
    url: "https://www.beautiful.ai",
    shortDescription: "AI-powered presentation maker with smart slide templates that auto-adapt",
    supportType: ["visual"],
    category: "visualization & design",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "very-limited", // 14-day trial
    personaTypeMatch: ["presentation-focused", "ai-enthusiast", "quick-starter", "business-oriented", "professional-user"],
    timePressure: "low",
    strengths: ["AI design assistance", "Auto-adapting slides", "Professional templates", "Collaboration features", "Analytics", "slides", "beautiful-visualizations"],
    weaknesses: ["Limited free tier", "Subscription required", "Less customization than manual tools"],
    complexity: "beginner"
  },
  {
    id: "figma",
    name: "Figma",
    url: "https://www.figma.com",
    shortDescription: "UI/UX design, collaborative whiteboarding",
  supportType: ["visual", "research"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["collaborative-worker", "design-focused", "brainstormer"],
    timePressure: "high",
    strengths: ["Industry standard", "Real-time collaboration", "Powerful design tools", "beautiful-visualizations", "Clean UI"],
    weaknesses: ["Steep learning curve", "Requires design knowledge", "Relies on internet connection"],
    complexity: "intermediate"
  },
  {
    id: "figjam",
    name: "FigJam",
    url: "https://www.figma.com/figjam",
    shortDescription: "UI/UX design, collaborative whiteboarding",
  supportType: ["visual", "research"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["brainstormer", "collaborative-worker"],
    timePressure: "low",
    strengths: ["Easy brainstorming", "Real-time collaboration", "Templates", "idea-generation"],
    weaknesses: ["Less powerful than full Figma", "Requires internet"],
    complexity: "beginner"
  },
  {
    id: "miro",
    name: "Miro",
    url: "https://miro.com",
    shortDescription: "Collaborative whiteboarding and mind mapping",
    supportType: ["visual", "research"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["brainstormer", "collaborative-worker"],
    timePressure: "low",
    strengths: ["Infinite canvas", "Great for brainstorming", "Real-time collaboration", "Templates", "diagramming", "idea-generation", "Clean UI"],
    weaknesses: ["Can get messy", "Free version limited"],
    complexity: "beginner"
  },
  {
    id: "excalidraw",
    name: "Excalidraw",
    url: "https://excalidraw.com",
    shortDescription: "Open-source whiteboard for sketching hand-drawn-like diagrams and wireframes",
    supportType: ["visual", "research"],
    category: "visualization & design",
    aiDependency: "manual-only",
    price: "freemium",
    freeTierAccess: "robust", // Free open-source editor
    personaTypeMatch: ["brainstormer", "collaborative-worker", "open-source-advocate", "quick-starter", "web-focused", "design-focused"],
    timePressure: "low",
    strengths: ["Hand-drawn aesthetic", "Real-time collaboration", "Open source", "Export to multiple formats", "diagramming", "brainstorming", "wireframing"],
    weaknesses: ["Limited advanced features", "Hand-drawn style may not suit all needs", "Paid tier for presentations"],
    complexity: "beginner"
  },
  {
    id: "arcgis",
    name: "ArcGIS Online",
    url: "https://www.arcgis.com",
    shortDescription: "Interactive maps, dashboards, spatial storytelling",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "manual-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["data-focused", "analytical-thinker", "spatial-thinker", "story-teller"],
    timePressure: "high",
    strengths: ["Powerful mapping", "Data visualization", "Professional grade", "interactive", "good-at-analysis"],
    weaknesses: ["Complex for beginners", "Limited free tier"],
    complexity: "advanced"
  },
  {
    id: "qgis",
    name: "QGIS",
    url: "https://qgis.org",
    shortDescription: "Free, open-source geographic information system",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "manual-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["data-focused", "spatial-thinker", "open-source-advocate"],
    timePressure: "high",
    strengths: ["Powerful mapping", "Data visualization", "Free and open-source", "Powerful GIS tools", "Cross-platform"],
    weaknesses: ["Steep learning curve", "Interface can be overwhelming", "Can be buggy"],
    complexity: "advanced"
  },
  {
    id: "atlas",
    name: "Atlas",
    url: "https://atlas.co/",
    shortDescription: "Modern mapping and data visualization platform",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "manual-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["data-focused", "spatial-thinker", "visual-learner", "quick-starter", "web-focused", "idea-tester"],
    timePressure: "medium",
    strengths: ["Modern interface", "Easy to use", "Brower-based", "Beautiful visualizations", "mapping", "data visualization", "clean UI"],
    weaknesses: ["Limited free tier", "Less powerful than QGIS or ArcGIS"],
    complexity: "beginner"
  },
  {
    id: "looker",
    name: "Looker Studio",
    url: "https://lookerstudio.google.com",
    shortDescription: "Custom interactive dashboards by Google",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["data-focused", "analytical-thinker", "google-user", "visual-learner"],
    timePressure: "medium",
    strengths: ["Free", "Google integration", "Professional dashboards", "data-visualization", "dashboard", "interactive", "statistics"],
    weaknesses: ["Learning curve", "Google ecosystem dependent", "Can be slow"],
    complexity: "intermediate"
  },
  {
    id: "flourish",
    name: "Flourish",
    url: "https://flourish.studio",
    shortDescription: "Interactive data visualization",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["visual-learner", "story-teller"],
    timePressure: "low",
    strengths: ["Beautiful visualizations", "Easy to use", "Interactive", "data-visualization", "synthesis"],
    weaknesses: ["Limited customization on free", "Template-based"],
    complexity: "beginner"
  },
  {
    id: "tableau",
    name: "Tableau Public",
    url: "https://public.tableau.com",
    shortDescription: "Interactive visual dashboards",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "manual-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["data-focused", "analytical-thinker", "patient-learner", "self-directed"],
    timePressure: "high",
    strengths: ["Industry standard", "Powerful", "Free public version", "data-visualization", "interactive", "statistics", "good-at-analysis"],
    weaknesses: ["Steep learning curve", "Data must be public", "Data storage limits"],
    complexity: "advanced"
  },
  {
    id: "julius-ai",
    name: "Julius AI",
    url: "https://julius.ai",
    shortDescription: "AI-powered data analyst for analyzing spreadsheets and creating visualizations through natural language",
    supportType: ["data", "visual", "research"],
    category: ["visualization & design", "research, knowledge, & learning platforms"],
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "very-limited", // 15 messages per month
    personaTypeMatch: ["data-focused", "ai-enthusiast", "prompt-based-user", "analytical-thinker", "spreadsheet-user"],
    timePressure: "low",
    strengths: ["Natural language queries", "Advanced statistical analysis", "Notebooks feature", "data-visualization",  "Database connectors", "good-at-analysis", "statistics"],
    weaknesses: ["Limited free tier", "Requires AI knowledge", "Subscription for advanced models"],
    complexity: "beginner"
  },
  {
    id: "apache-spark",
    name: "Apache Spark",
    url: "https://spark.apache.org",
    shortDescription: "Open-source unified analytics engine for large-scale data processing",
    supportType: ["data", "coding"],
    category: "research, knowledge, & learning platforms",
    aiDependency: "manual-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["self-directed", "open-source-advocate", "data-focused", "analytical-thinker", "technical-learner", "research-focused", "academic-researcher"],
    timePressure: "high",
    strengths: ["Big data processing", "Distributed computing", "Fast analytics", "Free and open-source", "statistics", "good-at-analysis"],
    weaknesses: ["Steep learning curve", "Requires programming knowledge", "Complex setup"],
    complexity: "advanced"
  },
  {
    id: "power-bi",
    name: "Power BI",
    url: "https://powerbi.microsoft.com",
    shortDescription: "Business analytics tool for interactive visualizations and business intelligence",
    supportType: ["data", "visual"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["data-focused", "analytical-thinker", "business-oriented"],
    timePressure: "medium",
    strengths: ["Business intelligence", "Interactive dashboards", "Microsoft integration", "statistics", "good-at-analysis", "data-visualization"],
    weaknesses: ["Learning curve", "Best with Microsoft ecosystem", "Free version has limitations"],
    complexity: "intermediate"
  },
  {
    id: "infogram",
    name: "Infogram",
    url: "https://infogram.com",
    shortDescription: "Infographics and visual reports",
    supportType: ["visual", "data"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["visual-learner", "quick-starter", "data-focused"],
    timePressure: "low",
    strengths: ["Great templates", "Easy infographics", "Charts and maps", "data-visualization"],
    weaknesses: ["Limited free tier", "Can look generic"],
    complexity: "beginner"
  },
  {
    id: "whimsical",
    name: "Whimsical",
    url: "https://whimsical.com",
    shortDescription: "Flowcharts, wireframes, & docs + AI to auto-generate diagrams from prompts",
    supportType: ["visual","research"],
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["collaborative-worker", "planning-focused", "brainstormer"],
    timePressure: "low",
    strengths: ["Diagramming", "Clean interface", "Great for planning", "clean UI"],
    weaknesses: ["Limited free tier", "Focused on specific use cases"],
    complexity: "beginner"
  },
  {
    id: "diagrams",
    name: "Diagrams.net",
    url: "https://app.diagrams.net",
    shortDescription: "Open-source platform for creating flowcharts, UML diagrams, mind maps",
    supportType: "visual",
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["technical-learner", "open-source-advocate", "systematic-builder"],
    timePressure: "medium",
    strengths: ["Completely free", "Powerful", "No account needed", "AI Smart Templates", "diagramming"],
    weaknesses: ["Interface can be cluttered", "AI features limited to Cloud version"],
    complexity: "intermediate"
  },
  {
    id: "piktochart",
    name: "Piktochart",
    url: "https://piktochart.com",
    shortDescription: "Visual storytelling, infographic, & design tool",
    supportType: "visual",
    category: "visualization & design",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["story-teller", "visual-learner", "report-focused"],
    timePressure: "low",
    strengths: ["Great for reports", "Professional templates", "Easy to use", "infographics"],
    weaknesses: ["Limited free tier", "Template-dependent"],
    complexity: "beginner"
  },

  // Image Generation Tools
  {
    id: "midjourney",
    name: "Midjourney",
    url: "https://www.midjourney.com",
    shortDescription: "AI image generator from text prompts",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["artistic", "quality-focused"],
    timePressure: "medium",
    strengths: ["Highest quality", "Artistic style", "Community","image-generation"],
    weaknesses: ["Requires Discord", "No free tier", "Learning curve for prompts"],
    complexity: "intermediate"
  },
  {
    id: "dalle",
    name: "DALL-E",
    url: "https://openai.com/dall-e",
    shortDescription: "AI image generator from text prompts",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["rapid-prototyper", "artistic", "ai-enthusiast", "creative-expresser"],
    timePressure: "low",
    strengths: ["Easy to use", "Good integration", "Consistent results", "image-generation"],
    weaknesses: ["Credit system", "Less artistic than Midjourney"],
    complexity: "beginner"
  },
  {
    id: "bing-creator",
    name: "Bing Image Creator",
    url: "https://www.bing.com/images/create",
    shortDescription: "AI image generator from text prompts",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["budget-conscious", "quick-starter", "microsoft-user", "idea-tester"],
    timePressure: "low",
    strengths: ["Completely free", "No signup required", "Microsoft integration", "image-generation"],
    weaknesses: ["Less control", "Quality varies", "Limited styles"],
    complexity: "beginner"
  },
  {
    id: "ms-designer",
    name: "Microsoft Designer",
    url: "https://designer.microsoft.com",
    shortDescription: "AI image generator from text and image prompts with AI-powered graphic design tools",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["microsoft-user", "design-focused", "quick-starter", "idea-tester"],
    timePressure: "low",
    strengths: ["AI + design tools", "Microsoft integration", "Templates", "image-generation"],
    weaknesses: ["New platform", "Microsoft ecosystem dependent"],
    complexity: "beginner"
  },
  {
    id: "freepik-ai",
    name: "Freepik",
    url: "https://www.freepik.com",
    shortDescription: "AI image generator from text prompts",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["stock-photo-user", "quick-starter"],
    timePressure: "low",
    strengths: ["Stock photos + AI", "Variety of styles", "Easy to use", "image-generation"],
    weaknesses: ["Limited free generation", "Watermarks on free"],
    complexity: "beginner"
  },
  {
    id: "stable-diffusion",
    name: "Stable Diffusion",
    url: "https://stability.ai",
    shortDescription: "Generates high-quality, photorealistic images from text prompts",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["technical-learner", "open-source-advocate", "quality-focused", "safety-conscious", "self-directed"],
    timePressure: "high",
    strengths: ["High quality", "Open source", "Customizable", "image-generation"],
    weaknesses: ["Technical setup", "Learning curve", "Resource intensive"],
    complexity: "advanced"
  },
  {
    id: "ideogram",
    name: "Ideogram",
    url: "https://ideogram.ai",
    shortDescription: "AI image generator specializing in creating images with legible and customizable text",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["text-in-image-focused", "logo-designer", "ai-enthusiast", "content-creator"],
    timePressure: "low",
    strengths: ["Great with text", "High quality", "Easy to use", "image-generation"],
    weaknesses: ["Limited free tier", "Newer platform", "Credit system"],
    complexity: "beginner"
  },
  {
    id: "adobe-firefly",
    name: "Adobe Firefly",
    url: "https://firefly.adobe.com",
    shortDescription: "Suite of generative AI models integrated into Adobe products focused on images and text effects",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["adobe-user", "professional-user", "creative-expresser", "safety-conscious", "artistic", "ai-enthusiast"],
    timePressure: "low",
    strengths: ["Adobe integration", "Professional grade", "Safe for commercial use", "image-generation"],
    weaknesses: ["Adobe ecosystem", "Limited free tier", "Subscription model"],
    complexity: "intermediate"
  },
  {
    id: "flux",
    name: "FLUX.1",
    url: "https://flux-ai.io",
    shortDescription: "AI image generator from text prompts",
    supportType: "visual",
    category: "image generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["early-adopter", "quality-focused", "ai-enthusiast", "artistic", "creative-expresser"],
    timePressure: "low",
    strengths: ["High quality", "Fast generation", "Good prompt following", "image-generation"],
    weaknesses: ["Newer platform", "Limited free tier", "Credit system"],
    complexity: "beginner"
  },
  {
    id: "leonardo-ai",
    name: "Leonardo AI",
    url: "https://leonardo.ai",
    shortDescription: "Platform for image, concept art, and video generation",
    supportType: ["visual","video"], 
    category: ["image generation", "video generation & editing"],
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["artistic", "concept-artist"],
    timePressure: "medium",
    strengths: ["Game/concept art focused", "Multiple models", "Training options", "image-generation", "video-generation"],
    weaknesses: ["Learning curve", "Credit system", "Can be overwhelming"],
    complexity: "intermediate"
  },

  // Writing & Text Generation Tools
  {
    id: "chatgpt",
    name: "ChatGPT",
    url: "https://chat.openai.com",
    shortDescription: "Conversational AI for writing, coding, data analysis, image generation, web browsing, problem-solving, and brainstorming",
    supportType: ["coding", "text", "research", "data"],
    category: ["writing & text generation", "research, knowledge, & learning platforms"],
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["multimodal-user", "conversational-learner", "ai-enthusiast", "quick-starter", "brainstormer", "idea-tester"],
    timePressure: "low",
    strengths: ["Versatile", "Conversational", "Widely known", "Good reasoning", "summarization", "debugging"],
    weaknesses: ["Usage limits on free", "Can hallucinate", "No real-time data"],
    complexity: "beginner"
  },
  {
    id: "gpt5o",
    name: "GPT-5o",
    url: "https://chat.openai.com",
    shortDescription: "Advanced AI model with enhanced reasoning, coding, vision, voice capabilities, real-time web search, and complex problem-solving",
    supportType: ["coding", "text", "research", "data"],
    category: ["writing & text generation", "research, knowledge, & learning platforms"],
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["multimodal-user", "power-user", "professional-writer", "analytical-thinker", "professional-user", "quality-focused"],
    timePressure: "low",
    strengths: ["Most advanced", "Multimodal", "Best reasoning", "summarization", "debugging"],
    weaknesses: ["Expensive", "Usage limits", "Requires subscription"],
    complexity: "beginner"
  },
  {
    id: "claude",
    name: "Claude.ai",
    url: "https://claude.ai",
    shortDescription: "AI assistant with Artifacts for coding, writing, data analysis, document processing, visual analysis, and in-depth research with long context windows",
    supportType: ["coding", "text", "research", "data"],
    category: ["writing & text generation", "web & app builders"],
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ['code-curious', 'developer', "brainstormer", "multimodal-user", "analytical-thinker", "safety-conscious", "conversational-learner"],
    timePressure: "low",
    strengths: ["Long context", "Debugging", "Good at analysis", "Helpful", "summarization", "debugging"],
    weaknesses: ["Limited free tier", "Usage and model choice limits"],
    complexity: "beginner"
  },
  {
    id: "gemini",
    name: "Gemini",
    url: "https://gemini.google.com",
    shortDescription: "Google's multimodal AI for writing, coding, image/video analysis, real-time web search, Google Workspace integration, and long-context understanding",
    supportType: ["text", "coding", "research", "data"],
    category: ["writing & text generation", "research, knowledge, & learning platforms"],
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["google-user", "multimodal-user", "conversational-learner", "brainstormer", "idea-tester"],
    timePressure: "low",
    strengths: ["Google integration", "Multimodal", "Good free tier", "summarization", "debugging"],
    weaknesses: ["Google ecosystem", "Inconsistent quality", "Privacy concerns"],
    complexity: "beginner"
  },
  {
    id: "notion-ai",
    name: "Notion AI",
    url: "https://www.notion.so",
    shortDescription: "Embedded AI writing in notes and docs",
    supportType: ["text", "research"],
    category: ["writing & text generation", "research, knowledge, & learning platforms"],
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["organized-planner", "note-taker", "productivity-focused", "knowledge-manager", "brainstormer"],
    timePressure: "medium",
    strengths: ["Integrated workspace", "Database features", "Templates"],
    weaknesses: ["AI costs extra", "Can be overwhelming"],
    complexity: "intermediate"
  },
  {
    id: "copy-ai",
    name: "Copy.ai",
    url: "https://www.copy.ai",
    shortDescription: "Marketing and ad copy generation",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["marketing-focused", "copywriter", "business-oriented"],
    timePressure: "low",
    strengths: ["Marketing templates", "Multiple formats", "Easy to use"],
    weaknesses: ["Limited to marketing", "Generic output", "Credit system"],
    complexity: "beginner"
  },
  {
    id: "jasper",
    name: "Jasper",
    url: "https://www.jasper.ai",
    shortDescription: "Marketing and ad copy generation",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["marketing-focused", "professional-user", "business-oriented"],
    timePressure: "low",
    strengths: ["Professional grade", "Brand voice", "Integrations"],
    weaknesses: ["Expensive", "Marketing focused", "Steep learning curve"],
    complexity: "intermediate"
  },
  {
    id: "writesonic",
    name: "Writesonic",
    url: "https://writesonic.com",
    shortDescription: "Marketing and ad copy generation",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["marketing-focused", "quick-starter","business-oriented"],
    timePressure: "low",
    strengths: ["Affordable", "Multiple tools", "Easy to use"],
    weaknesses: ["Quality varies", "Limited free tier", "Marketing focused"],
    complexity: "beginner"
  },
  {
    id: "sudowrite",
    name: "Sudowrite",
    url: "https://www.sudowrite.com",
    shortDescription: "Creative fiction writing support",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["creative-writer", "story-teller", "fiction-focused"],
    timePressure: "medium",
    strengths: ["Creative-writing focused", "Story development", "Character building"],
    weaknesses: ["Expensive", "Fiction only", "Learning curve"],
    complexity: "intermediate"
  },
  {
    id: "grammarly",
    name: "Grammarly",
    url: "https://www.grammarly.com",
    shortDescription: "AI-powered grammar and style correction",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["perfectionist", "professional-writer", "editor-focused"],
    timePressure: "low",
    strengths: ["Instant corrections", "Writing insights", "Browser integration", "proofreading"],
    weaknesses: ["Can be overly cautious", "Premium features costly"],
    complexity: "beginner"
  },
  {
    id: "quillbot",
    name: "QuillBot",
    url: "https://quillbot.com",
    shortDescription: "AI paraphrasing and grammar checking tool with multiple writing modes",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["editor-focused", "perfectionist", "quick-starter","web-focused", "professional-writer", "ai-enthusiast"],
    timePressure: "low",
    strengths: ["Paraphrasing modes", "Grammar checker", "Summarizer", "plagiarism checker", "proofreading", "summarization", "clean UI"],
    weaknesses: ["125-word limit on free", "Premium needed for full features", "AI can miss context"],
    complexity: "beginner"
  },
  {
    id: "wordtune",
    name: "Wordtune",
    url: "https://www.wordtune.com",
    shortDescription: "AI writing assistant for rewriting and improving clarity and tone",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["editor-focused", "professional-writer", "perfectionist"],
    timePressure: "low",
    strengths: ["Clarity improvements", "Tone adjustments", "Length control", "Fact-checking", "proofreading", "summarization"],
    weaknesses: ["Limited free rewrites", "Subscription for unlimited", "Can change meaning"],
    complexity: "beginner"
  },
  {
    id: "prowritingaid",
    name: "ProWritingAid",
    url: "https://prowritingaid.com",
    shortDescription: "AI-powered grammar and style correction",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["professional-writer", "editor-focused", "perfectionist"],
    timePressure: "medium",
    strengths: ["Detailed analysis", "Style suggestions", "Affordable", "proofreading"],
    weaknesses: ["Complex interface", "Can be overwhelming", "Slower than Grammarly"],
    complexity: "intermediate"
  },
  {
    id: "scribe",
    name: "Scribe",
    url: "https://scribehow.com",
    shortDescription: "Automatically documents processes from screen recordings",
    supportType: "text",
    category: "writing & text generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["documentation-focused", "ai-enthusiast", "accessibility-focused"],
    timePressure: "low",
    strengths: ["Automatic documentation", "Screen recording", "Step-by-step guides"],
    weaknesses: ["Limited to process docs", "Requires browser extension", "Credit system"],
    complexity: "beginner"
  },

  // Speech & Voice Interaction Tools
  {
    id: "wispr-flow",
    name: "Wispr Flow",
    url: "https://wisprflow.ai/",
    shortDescription: "Voice-to-text dictation tool with AI-powered transcription",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["quick-starter", "productivity-focused", "note-taker"],
    timePressure: "bolt",
    strengths: ["Real-time dictation", "Easy to use", "Multiple platforms", "speech-tools", "STT"],
    weaknesses: ["Limited free tier", "Requires subscription for full features", "Internet connection needed"],
    complexity: "beginner"
  },
  {
    id: "speechnotes",
    name: "Speechnotes",
    url: "https://speechnotes.co/",
    shortDescription: "Free online speech-to-text notepad with continuous dictation",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["quick-starter", "note-taker", "accessibility-focused"],
    timePressure: "low",
    strengths: ["No signup required", "Continuous dictation", "Auto-save", "speech-tools", "STT"],
    weaknesses: ["Basic features", "Ads in free version", "Browser-dependent"],
    complexity: "beginner"
  },
  {
    id: "natural-readers",
    name: "Natural Readers",
    url: "https://www.naturalreaders.com/",
    shortDescription: "Text-to-speech software with natural-sounding voices",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["accessibility-focused", "audio-learner", "quick-starter", "proofreader"],
    timePressure: "low",
    strengths: ["Natural voices", "Multiple formats supported", "Reading assistance", "speech-tools", "TTS"],
    weaknesses: ["Limited voices in free tier", "Credit system", "Some features require paid version"],
    complexity: "beginner"
  },
  {
    id: "whisper",
    name: "Whisper by OpenAI",
    url: "https://openai.com/research/whisper",
    shortDescription: "High-accuracy speech-to-text models",
    supportType: ["audio","coding"],
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["technical-learner", "open-source-advocate", "transcription-focused"],
    timePressure: "high",
    strengths: ["Highly accurate", "Multiple languages", "Open source", "STT"],
    weaknesses: ["Technical setup", "No web interface", "Developer-focused"],
    complexity: "advanced"
  },
  {
    id: "speechify",
    name: "Speechify",
    url: "https://speechify.com",
    shortDescription: "Text-to-speech with realistic voices",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["accessibility-focused", "audio-learner", "safety-conscious"],
    timePressure: "low",
    strengths: ["Natural voices", "Speed control", "Multiple platforms", "speech-tools", "TTS", "voiceover"],
    weaknesses: ["Limited free tier", "Subscription model", "Voice quality varies"],
    complexity: "beginner"
  },
  {
    id: "elevenlabs",
    name: "ElevenLabs",
    url: "https://elevenlabs.io",
    shortDescription: "Text-to-speech with realistic voices",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["voice-focused", "content-creator", "quality-focused"],
    timePressure: "low",
    strengths: ["Highest quality voices", "Voice cloning", "Multiple languages", "voiceover", "TTS"],
    weaknesses: ["Limited free tier", "Expensive", "Ethical concerns"],
    complexity: "beginner"
  },
  {
    id: "murf",
    name: "Murf.ai",
    url: "https://murf.ai",
    shortDescription: "Text-to-speech with realistic voices",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["business-oriented", "professional-narrator", "safety-conscious"],
    timePressure: "low",
    strengths: ["Business-focused", "Multiple voices", "Easy to use", "speech-tools", "TTS", "voiceover"],
    weaknesses: ["Limited free tier", "Less natural than ElevenLabs", "Credit system"],
    complexity: "beginner"
  },
  {
    id: "google-speech",
    name: "Google Cloud Speech-to-Text",
    url: "https://cloud.google.com/speech-to-text",
    shortDescription: "Speech-to-text for apps, websites",
    supportType: ["audio", "coding"],
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["developer", "technical-learner", "google-ecosystem", "systematic-builder"],
    timePressure: "high",
    strengths: ["Developer-focused", "Highly accurate", "Scalable", "STT"],
    weaknesses: ["Technical setup", "Not for general users", "Pricing complexity"],
    complexity: "advanced"
  },
  {
    id: "azure-speech",
    name: "Microsoft Azure Speech Services",
    url: "https://azure.microsoft.com/en-us/products/cognitive-services/speech-services",
    shortDescription: "Speech-to-text & text-to-speech for apps, websites",
    supportType: ["audio", "coding"],
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["developer", "technical-learner", "microsoft-ecosystem", "systematic-builder"],
    timePressure: "high",
    strengths: ["Developer-focused", "Both STT and TTS", "Microsoft integration", "STT", "TTS"],
    weaknesses: ["Technical setup", "Not for general users", "Complex pricing"],
    complexity: "advanced"
  },
  {
    id: "otter-ai",
    name: "Otter.ai",
    url: "https://otter.ai",
    shortDescription: "AI transcription and meeting notes with speaker identification",
    supportType: "audio",
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["meeting-focused", "professional-user", "note-taker", "accessibility-focused"],
    timePressure: "low",
    strengths: ["Real-time transcription", "Speaker ID", "Meeting assistant", "Timestamps", "Zoom integration", "speech-tools", "STT"],
    weaknesses: ["Limited free minutes", "Subscription for full features", "Requires internet"],
    complexity: "beginner"
  },
  {
    id: "voiceflow",
    name: "Voiceflow",
    url: "https://www.voiceflow.com",
    shortDescription: "Conversational interface builders (voice/chat)",
    supportType: ["bot","coding"],
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["chatbot-builder", "developer", "technical-learner", "systematic-builder"],
    timePressure: "medium",
    strengths: ["Visual builder", "No coding required", "Multi-platform"],
    weaknesses: ["Learning curve", "Limited free tier", "Complex for simple bots"],
    complexity: "intermediate"
  },
  {
    id: "botpress",
    name: "Botpress",
    url: "https://botpress.com",
    shortDescription: "Conversational interface builders (voice/chat)",
    supportType: ["bot", "coding"],
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["developer", "open-source-advocate", "chatbot-builder", "technical-learner", "systematic-builder"],
    timePressure: "high",
    strengths: ["Open source", "Powerful", "Self-hosted option"],
    weaknesses: ["Technical complexity", "Developer-focused", "Learning curve"],
    complexity: "advanced"
  },
  {
    id: "rasa",
    name: "Rasa",
    url: "https://rasa.com",
    shortDescription: "Conversational interface builders (voice/chat)",
    supportType: ["bot", "coding"],
    category: "speech & voice interaction",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["developer", "open-source-advocate", "chatbot-builder", "technical-learner", "systematic-builder"],
    timePressure: "high",
    strengths: ["Open source", "Highly customizable", "Machine learning focused"],
    weaknesses: ["Very technical", "Steep learning curve", "Requires ML knowledge"],
    complexity: "advanced"
  },

  // Audio & Music Generation Tools
  {
    id: "descript",
    name: "Descript",
    url: "https://www.descript.com",
    shortDescription: "Audio/video editing from transcript, overdub voices",
    supportType: ["audio", "video"],
    category: ["audio & music generation", "video generation & editing"],
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["podcaster", "content-creator"],
    timePressure: "medium",
    strengths: ["Edit like text", "Voice cloning", "Transcription", "Innovative", "audio-editing", "voiceover"],
    weaknesses: ["Learning curve", "Limited free tier", "Subscription model"],
    complexity: "intermediate"
  },

  {
    id: "audacity",
    name: "Audacity",
    url: "https://www.audacityteam.org",
    shortDescription: "Open-source audio editing",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "manual-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["open-source-advocate", "podcaster", "content-creator"],
    timePressure: "medium",
    strengths: ["Completely free", "Powerful", "Cross-platform", "No limits", "audio-editing"],
    weaknesses: ["Dated interface", "Manual workflow", "Learning curve"],
    complexity: "intermediate"
  },
  {
    id: "adobe-podcast",
    name: "Adobe Podcast",
    url: "https://podcast.adobe.com",
    shortDescription: "Audio recording/editing with AI-enhancement options",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["podcaster", "content-creator", "adobe-user"],
    timePressure: "low",
    strengths: ["AI enhancement", "Easy to use", "Web-based", "audio-editing"],
    weaknesses: ["Limited features", "Adobe ecosystem", "Internet required"],
    complexity: "beginner"
  },
  {
    id: "cleanvoice",
    name: "Cleanvoice.ai",
    url: "https://cleanvoice.ai",
    shortDescription: "Removes filler words, stutters",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["podcaster", "professional-speaker"],
    timePressure: "low",
    strengths: ["Automatic cleanup", "Time-saving", "Professional results", "audio-editing"],
    weaknesses: ["Expensive", "Limited free trial", "Specific use case"],
    complexity: "beginner"
  },
  {
    id: "krisp",
    name: "Krisp",
    url: "https://krisp.ai",
    shortDescription: "Real-time noise suppression",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["remote-worker", "meeting-focused", "professional-user"],
    timePressure: "low",
    strengths: ["Instant processing", "Works with any app", "Easy setup"],
    weaknesses: ["Limited free minutes", "Subscription model", "Resource intensive"],
    complexity: "beginner"
  },
  {
    id: "voicemod",
    name: "Voicemod",
    url: "https://www.voicemod.net",
    shortDescription: "Real-time voice changing",
    supportType: "video",
    category: "audio & music generation",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["gamer", "streamer", "creative-expresser", "content-creator"],
    timePressure: "low",
    strengths: ["Instant effects", "Fun and creative", "Gaming integration", "voiceover"],
    weaknesses: ["Limited professional use", "Can be gimmicky", "Resource intensive"],
    complexity: "beginner"
  },
  {
    id: "aiva",
    name: "AIVA",
    url: "https://www.aiva.ai",
    shortDescription: "Composes symphonic-style music",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["music-lover", "composer", "film-scorer"],
    timePressure: "medium",
    strengths: ["Classical music focus", "High quality", "Copyright ownership", "music-creation"],
    weaknesses: ["Limited styles", "Classical focus only", "Learning curve"],
    complexity: "intermediate"
  },
  {
    id: "soundraw",
    name: "Soundraw",
    url: "https://soundraw.io",
    shortDescription: "AI-generated background music",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["content-creator", "music-lover"],
    timePressure: "low",
    strengths: ["Royalty-free", "Customizable", "Multiple genres", "music-creation"],
    weaknesses: ["Background music only", "Limited free tier", "Subscription model"],
    complexity: "beginner"
  },
  {
    id: "beatoven",
    name: "Beatoven",
    url: "https://www.beatoven.ai",
    shortDescription: "AI-generated background music",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["content-creator", "mood-focused", "music-lover"],
    timePressure: "low",
    strengths: ["Mood-based generation", "Royalty-free", "Easy customization", "music-creation"],
    weaknesses: ["Background music focus", "Limited free tier", "Credit system"],
    complexity: "beginner"
  },
  {
    id: "mubert",
    name: "Mubert",
    url: "https://mubert.com",
    shortDescription: "AI-generated background music",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["streamer", "content-creator", "music-lover"],
    timePressure: "low",
    strengths: ["Endless music", "Real-time generation", "Multiple moods", "music-creation"],
    weaknesses: ["Repetitive", "Limited control", "Subscription for quality"],
    complexity: "beginner"
  },
  {
    id: "amper",
    name: "Amper Music",
    url: "https://www.ampermusic.com",
    shortDescription: "Royalty-free AI-generated music",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["content-creator", "commercial-user", "music-lover", "professional-user"],
    timePressure: "low",
    strengths: ["Professional quality", "Royalty-free", "Commercial use", "music-creation"],
    weaknesses: ["Expensive", "No free tier", "Limited trial"],
    complexity: "beginner"
  },
  {
    id: "boomy",
    name: "Boomy",
    url: "https://boomy.com",
    shortDescription: "Quick music generation with styles",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["rapid-prototyper", "music-lover"],
    timePressure: "low",
    strengths: ["Very easy", "Quick generation", "Share and monetize", "music-creation"],
    weaknesses: ["Generic quality", "Limited control", "Simple output"],
    complexity: "beginner"
  },
  {
    id: "suno",
    name: "Suno",
    url: "https://suno.com",
    shortDescription: "AI song and lyric generation from prompts",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["creative-expresser", "music-lover", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["Creates full songs", "Lyrics + music", "Multiple genres", "Easy to use" ,"music-creation"],
    weaknesses: ["AI-generated sound", "Limited control", "Credits system"],
    complexity: "beginner"
  },
  {
    id: "udio",
    name: "Udio",
    url: "https://www.udio.com",
    shortDescription: "AI music generator creating complete songs with vocals from text prompts",
    supportType: "audio",
    category: "audio & music generation",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["music-lover", "professional-user", "quality-focused", "creative-expresser"],
    timePressure: "medium",
    strengths: ["Full song generation", "Professional quality", "Multiple genres", "WAV/stem downloads", "music-creation"],
    weaknesses: ["Credit system", "Limited free tier", "Can sound AI-generated"],
    complexity: "beginner"
  },
  {
    id: "artlist-io",
    name: "Artlist.io",
    url: "https://artlist.io",
    shortDescription: "Royalty-free stock music, sound effects, footage, and video templates with AI tools",
    supportType: ["audio", "video"],
    category: ["audio & music generation", "video generation & editing"],
    aiDependency: "ai-optional", // Has AI video and image generators
    price: "paid",
    freeTierAccess: "very-limited", // No free tier, subscription required
    personaTypeMatch: ["content-creator", "video-creator", "professional-user", "commercial-user", "quality-focused"],
    timePressure: "medium",
    strengths: ["High-quality assets", "8K footage", "Unlimited downloads", "Commercial license", "AI tools", "Large library", "music-creation", "video-editing"],
    weaknesses: ["Subscription required", "No free tier", "Can be expensive"],
    complexity: "beginner"
  },

  // Video Generation & Editing Tools
  {
    id: "runway-ml",
    name: "Runway ML",
    url: "https://runwayml.com",
    shortDescription: "Video editing, optional AI-generated video from prompts",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["early-adopter", "video-creator", "experimental", "quality-focused"],
    timePressure: "medium",
    strengths: ["Cutting-edge AI video", "Multiple tools", "Professional quality", "video-generation"],
    weaknesses: ["Expensive", "Limited free tier", "New technology"],
    complexity: "intermediate"
  },
  {
    id: "pika-labs",
    name: "Pika Labs",
    url: "https://pika.art",
    shortDescription: "AI video generation from text",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["visual-learner", "quality-focused"],
    timePressure: "low",
    strengths: ["Easy to use", "Good quality", "Text-to-video", "video-generation"],
    weaknesses: ["Short videos only", "Limited control", "Credit system"],
    complexity: "beginner"
  },
  {
    id: "sora",
    name: "Sora by OpenAI",
    url: "https://openai.com/sora",
    shortDescription: "Text-to-video generation (limited access)",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["early-adopter", "professional-user", "visual-learner", "quality-focused"],
    timePressure: "medium",
    strengths: ["Highest quality", "Long videos", "Realistic", "video-generation"],
    weaknesses: ["Very limited access", "Expensive", "Waitlist only"],
    complexity: "beginner"
  },
  {
    id: "synthesia",
    name: "Synthesia",
    url: "https://www.synthesia.io",
    shortDescription: "AI avatar video generation",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["training-creator", "professional-user"],
    timePressure: "low",
    strengths: ["Professional avatars", "Multiple languages", "Business-focused", "video-generation"],
    weaknesses: ["Expensive", "Limited free trial", "Uncanny valley"],
    complexity: "beginner"
  },
  {
    id: "heygen",
    name: "HeyGen",
    url: "https://www.heygen.com",
    shortDescription: "AI avatar video generation",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["video-marketer", "business-oriented", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["Easy to use", "Good avatars", "Multiple features", "video-generation"],
    weaknesses: ["Limited free tier", "Subscription model", "Quality varies"],
    complexity: "beginner"
  },
  {
    id: "elai",
    name: "Elai.io",
    url: "https://elai.io",
    shortDescription: "AI avatar video generation",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["educator", "business-oriented"],
    timePressure: "low",
    strengths: ["E-learning focused", "Multiple avatars", "Easy interface", "video-generation", "CleanUI"],
    weaknesses: ["Limited free tier", "Niche focus", "Avatar limitations"],
    complexity: "beginner"
  },
  {
    id: "capcut",
    name: "CapCut",
    url: "https://www.capcut.com",
    shortDescription: "Free video editor with AI features for mobile and desktop",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["content-creator", "video-creator", "quick-starter"],
    timePressure: "low",
    strengths: ["No watermark on free", "AI captions", "Cross-platform", "Easy to use", "video-editing"],
    weaknesses: ["4K needs Pro", "Some effects locked", "Mobile-first design"],
    complexity: "beginner"
  },
  {
    id: "davinci-resolve",
    name: "DaVinci Resolve",
    url: "https://www.blackmagicdesign.com/products/davinciresolve",
    shortDescription: "Professional video editing, color grading, and VFX software",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "manual-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["professional-user", "video-creator", "technical-learner", "quality-focused", "patient-learner", "self-directed"],
    timePressure: "high",
    strengths: ["Professional grade", "Color grading", "VFX tools", "One-time purchase", "4K support", "video-editing"],
    weaknesses: ["Steep learning curve", "Resource intensive", "Complex interface"],
    complexity: "advanced"
  },
  {
    id: "clipchamp",
    name: "Clipchamp",
    url: "https://clipchamp.com",
    shortDescription: "Microsoft's web-based video editor with AI features",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["quick-starter", "content-creator", "video-creator", "microsoft-user", "web-focused"],
    timePressure: "low",
    strengths: ["Web-based", "No watermark", "AI captions", "1080p free", "Microsoft integration", "video-editing"],
    weaknesses: ["4K needs Premium", "Limited effects on free", "Requires internet"],
    complexity: "beginner"
  },
  {
    id: "lumen5",
    name: "Lumen5",
    url: "https://lumen5.com",
    shortDescription: "Turns blog posts or text into short videos",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["content-creator", "video-creator"],
    timePressure: "low",
    strengths: ["Text-to-video", "Templates", "Social media focused", "video-generation"],
    weaknesses: ["Template-dependent", "Limited customization", "Watermark on free"],
    complexity: "beginner"
  },
  {
    id: "animoto",
    name: "Animoto",
    url: "https://animoto.com",
    shortDescription: "Video slideshows with optional AI assistance",
    supportType: ["video", "visual"],
    category: "video generation & editing",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["slideshow-creator", "video-creator", "quick-starter"],
    timePressure: "low",
    strengths: ["Very easy", "Templates", "Music library", "slides"],
    weaknesses: ["Basic features", "Template-dependent", "Limited free tier"],
    complexity: "beginner"
  },
  {
    id: "magisto",
    name: "Magisto",
    url: "https://www.magisto.com",
    shortDescription: "Auto-edit video with AI cuts, captions",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["content-creator", "accessibility-focused", "video-creator", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["Automatic editing", "Mobile-focused", "Quick results"],
    weaknesses: ["Limited control", "Mobile-centric", "Subscription model"],
    complexity: "beginner"
  },
  {
    id: "wisecut",
    name: "Wisecut",
    url: "https://www.wisecut.video",
    shortDescription: "Auto-edit video with AI cuts, captions",
    supportType: "video",
    category: "video generation & editing",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["content-creator", "accessibility-focused", "video-creator", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["Automatic cuts", "Remove silence", "Add music"],
    weaknesses: ["Limited control", "Credit system", "Quality varies"],
    complexity: "beginner"
  },

  // 3D Modeling, Spatial Design, & Video Games Tools
  {
    id: "unity",
    name: "Unity Engine",
    url: "https://unity.com",
    shortDescription: "Game engine for creating 2D and 3D games, simulations and other interactive experiences",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["game-developer", "technical-learner", "interactive-creator", "open-source-advocate", "growth-focused"],
    timePressure: "high",
    strengths: ["Industry standard", "Powerful", "Large community", "Cross-platform", "game-design", "simulations"],
    weaknesses: ["Steep learning curve", "Complex", "Resource intensive"],
    complexity: "advanced"
  },
  {
    id: "unreal",
    name: "Unreal Engine",
    url: "https://www.unrealengine.com",
    shortDescription: "3D computer graphics game engine for 3D games, simulations, and visualizations",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["growth-focused", "game-developer", "interactive-creator", "technical-learner", "open-source-advocate"],
    timePressure: "high",
    strengths: ["Cutting-edge graphics", "Powerful", "Blueprint system", "simulations", "game-design"],
    weaknesses: ["Very complex", "Resource intensive", "Steep learning curve"],
    complexity: "advanced"
  },
  {

    id: "godot",
    name: "Godot",
    url: "https://godotengine.org",
    shortDescription: "Free open-source game engine for 2D and 3D games",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "manual-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["growth-focused", "game-developer", "open-source-advocate", "interactive-creator", "patient-learner"],
    timePressure: "medium",
    strengths: ["Completely free", "No royalties", "Cross-platform", "2D and 3D", "game-design"],
    weaknesses: ["Smaller community than Unity", "Learning curve", "Fewer assets"],
    complexity: "intermediate"
  },
  {
    id: "twinmotion",
    name: "Twinmotion",
    url: "https://www.twinmotion.com",
    shortDescription: "Real-time 3D architectural visualization and rendering tool",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "manual-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["growth-focused", "architect", "real-estate-focused", "technical-learner", "spatial-thinker", "open-source-advocate"],
    timePressure: "medium",
    strengths: ["Architecture focused", "Unreal Integration", "Easy materials", "architecture", "simulations", "rendering", "templates"],
    weaknesses: ["Limited for general 3D", "Learning curve", "Technical Setup"],
    complexity: "intermediate"
  },
  {
    id: "meta-horizon",
    name: "Meta Horizon World",
    url: "https://www.meta.com/horizon-worlds",
    shortDescription: "Virtual reality game with an integrated game creation system; includes GenAI tools for meshes, assets, scripts, etc",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["vr-enthusiast", "experimental"],
    timePressure: "low",
    strengths: ["VR native", "Social", "AI tools", "No cost", "game-design"],
    weaknesses: ["Requires VR headset", "Meta ecosystem", "Limited audience"],
    complexity: "intermediate"
  },
  {
    id: "instantmesh",
    name: "InstantMesh",
    url: "https://github.com/TencentARC/InstantMesh",
    shortDescription: "AI framework for quickly generating 3D meshes from a single 2D image",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-only",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["ai-enthusiast", "technical-learner", "experimental", "open-source-advocate", "prompt-based-user"],
    timePressure: "medium",
    strengths: ["Cutting-edge AI", "Open source", "Image to 3D"],
    weaknesses: ["Technical setup", "Research project", "Limited support"],
    complexity: "advanced"
  },
  {
    id: "3d-model-studio",
    name: "3D-Model-Studio (Poe AI)",
    url: "https://poe.com",
    shortDescription: "Simple, web-based 3D model editor platform and 3D model generator",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["beginner-3d", "web-based-user", "web-focused", "quick-starter", "3d-artist", "idea-tester"],
    timePressure: "low",
    strengths: ["Web-based", "Easy to Use", "Simple interface", "3d-modeling"],
    weaknesses: ["Limited features", "Poe dependency", "Basic output"],
    complexity: "beginner"
  },
  {
    id: "blender",
    name: "Blender",
    url: "https://www.blender.org",
    shortDescription: "Open-source 3D creation suite",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "free",
    freeTierAccess: "robust",
    personaTypeMatch: ["growth-focused", "patient-learner", "open-source-advocate", "3d-artist", "professional-user"],
    timePressure: "high",
    strengths: ["Professional grade", "Versatile", "AI plugin ecosystem", "3d-modeling"],
    weaknesses: ["Extremely steep learning curve", "Intimidating interface", "Can be slow"],
    complexity: "advanced"
  },
  {
    id: "daz-studio",
    name: "Daz Studio",
    url: "https://www.daz3d.com",
    shortDescription: "Free 3D character creation, posing, and scene rendering software",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "manual-only",
    price: "freemium", // Base software free, Pro version and marketplace content paid
    freeTierAccess: "robust", // Free base software with full features
    personaTypeMatch: ["3d-artist", "character-designer", "visual-learner", "creative-expresser", "patient-learner"],
    timePressure: "medium",
    strengths: ["Character focused", "Professional rendering", "Large content marketplace", "Genesis platform", "3d-modeling", "rendering"],
    weaknesses: ["Content purchases add up", "Learning curve", "Resource intensive"],
    complexity: "intermediate"
  },
  {
    id: "meshy",
    name: "Meshy",
    url: "https://www.meshy.ai",
    shortDescription: "Turn images or prompts into 3D models",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["prompt-based-user", "ai-enthusiast", "rapid-prototyper"],
    timePressure: "low",
    strengths: ["AI-powered", "Easy to use", "Multiple input types"],
    weaknesses: ["Limited free tier", "AI limitations", "Quality varies"],
    complexity: "beginner"
  },
  {
    id: "luma-ai",
    name: "Luma AI",
    url: "https://lumalabs.ai",
    shortDescription: "Turn images or prompts into 3D models",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-only",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["prompt-based-user","3d-creator", "ai-enthusiast", "quick-starter", "quality-focused"],
    timePressure: "low",
    strengths: ["High quality", "Mobile app", "Photorealistic"],
    weaknesses: ["Limited free tier", "Mobile-focused", "Processing time"],
    complexity: "beginner"
  },
  {
    id: "kaedim",
    name: "Kaedim",
    url: "https://www.kaedim3d.com",
    shortDescription: "Turn images or prompts into 3D models",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["quality-focused", "prompt-based-user", "professional-user", "game-developer"],
    timePressure: "medium",
    strengths: ["Professional quality", "Game-ready models", "Clean topology", "game-design"],
    weaknesses: ["Expensive", "Limited free trial", "Professional focus"],
    complexity: "intermediate"
  },
  {
    id: "spline",
    name: "Spline",
    url: "https://spline.design",
    shortDescription: "Web-based 3D design with interactivity",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["web-focused", "quick-starter", "idea-tester"],
    timePressure: "medium",
    strengths: ["Web-based", "Easy to learn", "Interactive 3D", "3d-modeling"],
    weaknesses: ["Limited compared to desktop", "Internet required"],
    complexity: "intermediate"
  },
  {
    id: "sketchfab",
    name: "Sketchfab",
    url: "https://sketchfab.com",
    shortDescription: "Hosting and sharing 3D models",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "manual-only",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["sharer", "portfolio-builder", "community-focused"],
    timePressure: "low",
    strengths: ["Great for sharing", "Web viewer", "Large community"],
    weaknesses: ["Not for creation", "Sharing focused", "Limited editing"],
    complexity: "beginner"
  },
  {
    id: "adobe-substance",
    name: "Adobe Substance 3D",
    url: "https://www.adobe.com/products/substance3d.html",
    shortDescription: "Texture/material/asset design",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["3d-artist", "texture-artist", "game-developer", "professional-user", "quality-focused"],
    timePressure: "high",
    strengths: ["Industry standard", "Professional grade", "Material focus", "3d-modeling"],
    weaknesses: ["Expensive", "Adobe ecosystem", "Complex"],
    complexity: "advanced"
  },
  {
    id: "nvidia-omniverse",
    name: "NVIDIA Omniverse",
    url: "https://www.nvidia.com/en-us/omniverse",
    shortDescription: "3D design collaboration and simulation",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "robust",
    personaTypeMatch: ["nvidia-user", "simulation-focused", "game-developer"],
    timePressure: "high",
    strengths: ["Collaboration focused", "Nvidia integration", "Simulation", "community", "collaborative"],
    weaknesses: ["Complex", "Nvidia hardware preferred", "Enterprise focused"],
    complexity: "advanced"
  },
  {
    id: "realitycapture",
    name: "RealityCapture",
    url: "https://www.capturingreality.com",
    shortDescription: "Photogrammetry from 2D images",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "manual-only",
    price: "paid",
    freeTierAccess: "very-limited",
    personaTypeMatch: ["photogrammetry-user", "surveyor", "3d-artist", "professional-user"],
    timePressure: "high",
    strengths: ["Professional photogrammetry", "High accuracy", "Industry standard"],
    weaknesses: ["Expensive", "Specialized use", "Steep learning curve"],
    complexity: "advanced"
  },
  {
    id: "polycam",
    name: "Polycam",
    url: "https://poly.cam",
    shortDescription: "Photogrammetry and 3D scanning app for mobile devices",
    supportType: "3d",
    category: "3D modeling, spatial design, & video games",
    aiDependency: "ai-optional",
    price: "freemium",
    freeTierAccess: "somewhat-limited",
    personaTypeMatch: ["3d-artist", "mobile-3d-creator", "photogrammetry-user"],
    timePressure: "low",
    strengths: [
      "Easy mobile 3D scanning",
      "Photogrammetry from photos or LiDAR",
      "Exports to many 3D formats"],
    weaknesses: [
      "Limited free exports",
      "Best results on LiDAR devices",
      "Requires good lighting"],
    complexity: "beginner"
},
{
  id: "marble",
  name: "Marble",
  url: "https://marble.worldlabs.ai",
  shortDescription: "Generate immersive 3D worlds from text, images, or videos using AI world models",
  supportType: "3d",
  category: "3D modeling, spatial design, & video games",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited",
  personaTypeMatch: ["creative-expresser", "experimental", "early-adopter", "visual-learner", "ai-enthusiast", "prompt-based-user", "rapid-prototyper", "interactive-creator"],
  timePressure: "low",
  strengths: ["Persistent environments", "VR compatible", "Chisel editor", "Export to Gaussian splats and meshes", "game-design", "simulations"],
  weaknesses: ["New platform", "Processing time for high-fidelity", "Limited world expansion"],
  complexity: "beginner"
},
// Research, Knowledge, & Learning Platforms Tools
{
  id: "notion",
  name: "Notion",
  url: "https://www.notion.so",
  shortDescription: "All-in-one workspace for notes, databases, wikis, and project management",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "freemium",
  freeTierAccess: "robust", // Unlimited pages and blocks for individual use
  personaTypeMatch: ["organized-planner", "note-taker", "productivity-focused","knowledge-manager"],
  timePressure: "medium",
  strengths: ["Versatile workspace", "Database features", "Templates", "Clean UI"],
  weaknesses: ["Can be overwhelming", "Learning curve", "AI features cost extra"],
  complexity: "intermediate"
},
{
  id: "coda",
  name: "Coda",
  url: "https://coda.io",
  shortDescription: "Doc-database hybrid for building custom workflows and knowledge bases",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited to 1000 rows and 10 makers
  personaTypeMatch: ["systematic-builder", "workflow-optimizer", "technical-learner", "focus-driven", "self-directed"],
  timePressure: "high", // Complex to set up
  strengths: ["Powerful automations", "Custom workflows", "Formula system", "Database integration"],
  weaknesses: ["Steep learning curve", "Complex for simple notes", "Limited free tier"],
  complexity: "advanced"
},
{
  id: "obsidian",
  name: "Obsidian",
  url: "https://obsidian.md",
  shortDescription: "Powerful knowledge base with linked notes and graph visualization",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional", // Has AI plugins
  price: "freemium",
  freeTierAccess: "robust", // Free for personal use, very generous
  personaTypeMatch: ["knowledge-manager", "visual-learner", "note-taker", "self-directed"],
  timePressure: "medium",
  strengths: ["Linked notes", "Graph view", "Plugin ecosystem", "Local storage"],
  weaknesses: ["Learning curve", "Technical setup", "Can be complex"],
  complexity: "intermediate"
},
{
  id: "zotero",
  name: "Zotero",
  url: "https://www.zotero.org",
  shortDescription: "Research tool for collecting, organizing, citing, and sharing sources",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "manual-only",
  price: "freemium",
  freeTierAccess: "robust", // 300MB storage, unlimited items
  personaTypeMatch: ["academic-researcher", "citation-focused", "research-focused", "bibliography-builder"],
  timePressure: "low",
  strengths: ["Citation management", "Browser integration", "Collaborative libraries", "Free", "note-taking"],
  weaknesses: ["Academic focus", "Limited storage on free", "Interface could be modern"],
  complexity: "beginner"
},
{
  id: "endnote",
  name: "EndNote",
  url: "https://endnote.com",
  shortDescription: "Professional reference management and bibliography creation tool",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "manual-only",
  price: "paid",
  freeTierAccess: "very-limited", // No free version, only trial
  personaTypeMatch: ["professional-user", "academic-researcher", "citation-focused", "research-focused", "bibliography-builder"],
  timePressure: "medium",
  strengths: ["Professional grade", "Advanced features", "Institution support", "Comprehensive", "note-taking"],
  weaknesses: ["Expensive", "Complex", "No free version", "Steep learning curve"],
  complexity: "advanced"
},
{
  id: "connected-papers",
  name: "Connected Papers",
  url: "https://www.connectedpapers.com",
  shortDescription: "Visual tool for exploring academic paper connections and research landscapes",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited graphs per month
  personaTypeMatch: ["visual-learner", "academic-researcher", "citation-focused"],
  timePressure: "low",
  strengths: ["Visual paper connections", "Research discovery", "Beautiful interface", "Citation analysis", "Clean UI"],
  weaknesses: ["Limited free uses", "Academic papers only", "Subscription required for heavy use"],
  complexity: "beginner"
},
{
  id: "mindgrasp",
  name: "Mindgrasp",
  url: "https://mindgrasp.ai",
  shortDescription: "AI study tool that creates notes, summaries, and quizzes from any content",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited uploads and features
  personaTypeMatch: ["ai-enthusiast", "summary-focused", "quiz-creator", "study-optimizer"],
  timePressure: "low",
  strengths: ["Auto-generates notes", "Creates quizzes", "Multiple formats", "Study assistance", "synthesis", "summarization", "interactive"],
  weaknesses: ["AI dependency", "Limited free tier", "Quality varies with input"],
  complexity: "beginner"
},
{
  id: "curipod",
  name: "Curipod",
  url: "https://curipod.com",
  shortDescription: "AI-powered interactive lesson creator for educators",
  supportType: ["research", "visual"],
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited lessons and features
  personaTypeMatch: ["educator", "engagement-focused"],
  timePressure: "low",
  strengths: ["Interactive lessons", "Student engagement", "AI assistance", "Easy to use"],
  weaknesses: ["Education-specific", "Limited free tier", "Classroom-focused only"],
  complexity: "beginner"
},
{
  id: "edpuzzle",
  name: "Edpuzzle",
  url: "https://edpuzzle.com",
  shortDescription: "Interactive video lesson platform for educators and students",
  supportType: ["research", "visual"],
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "freemium",
  freeTierAccess: "robust", // Good free tier for teachers
  personaTypeMatch: ["educator", "engagement-focused", "multimedia-learner"],
  timePressure: "low",
  strengths: ["Video-based learning", "Student tracking", "Interactive elements", "Assessment tools"],
  weaknesses: ["Education-specific", "Video-dependent", "Requires teacher account"],
  complexity: "beginner"
},
{
  id: "nearpod",
  name: "Nearpod",
  url: "https://nearpod.com",
  shortDescription: "Interactive classroom engagement platform with real-time student participation",
  supportType: ["research", "visual"],
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited students and lessons
  personaTypeMatch: ["educator", "engagement-focused"],
  timePressure: "low",
  strengths: ["Real-time interaction", "Student engagement", "Lesson library", "Assessment tools"],
  weaknesses: ["Classroom-specific", "Limited free tier", "Requires student devices"],
  complexity: "beginner"
},
{
  id: "elicit",
  name: "Elicit",
  url: "https://elicit.com",
  shortDescription: "AI research assistant for literature reviews and paper analysis",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Free trial limited, paid plans start at $12/month
  personaTypeMatch: ["academic-researcher", "research-focused"],
  timePressure: "medium",
  strengths: ["Literature review automation", "Paper analysis", "125M+ papers", "Research workflows", "synthesis", "good-at-analysis", "summarization"],
  weaknesses: ["Academic focus only", "Limited free features", "Subscription required for full use"],
  complexity: "intermediate"
},
{
  id: "scispace",
  name: "SciSpace",
  url: "https://scispace.com",
  shortDescription: "AI-powered research agent for paper discovery and comprehension",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "robust", // Basic Plan: Free, offering Copilot answers from the standard model, with limitations
  personaTypeMatch: ["conversational-learner","research-focused","knowledge-manager"],
  timePressure: "low",
  strengths: ["Paper explanations", "270M+ papers", "Simple language", "AI copilot", "automation", "synthesis"],
  weaknesses: ["Academic papers only", "AI explanations may oversimplify", "Limited free tier"],
  complexity: "beginner"
},
{
  id: "scholarcy",
  name: "Scholarcy",
  url: "https://www.scholarcy.com",
  shortDescription: "AI tool that summarizes academic papers into key insights and flashcards",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // 5,000 free credits and then $1 for 1,000 credits
  personaTypeMatch: ["summary-focused", "quick-reader", "flashcard-learner", "academic-researcher", "research-focused", "knowledge-manager"],
  timePressure: "low",
  strengths: ["Paper summaries", "Flashcard creation", "Key insights", "Research highlights", "synthesis", "summarization", "interactive"],
  weaknesses: ["Credit-based system", "Academic focus", "AI may miss nuances"],
  complexity: "beginner"
},
{
  id: "perplexity",
  name: "Perplexity.ai",
  url: "https://www.perplexity.ai",
  shortDescription: "AI-powered search engine with real-time web access and citations",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "robust", // Free version provides basic search capabilities with citations and 5 Pro searches per day
  personaTypeMatch: ["growth-focused", "quick-starter","conversational-learner","research-focused","citation-focused"],
  timePressure: "low",
  strengths: ["Cited sources", "Pro searches daily", "Current information", "synthesis", "Clean UI"],
  weaknesses: ["Limited Pro searches", "AI may misinterpret", "Depends on web sources"],
  complexity: "beginner"
},
{
  id: "explainpaper",
  name: "Explainpaper",
  url: "https://www.explainpaper.com",
  shortDescription: "AI tool that explains complex academic papers in simple terms",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited uploads and explanations
  personaTypeMatch: ["summary-focused","academic-researcher", "quick-starter"],
  timePressure: "low",
  strengths: ["Simplifies complex papers", "Section-by-section explanation", "Highlights confusing parts", "Easy to use", "synthesis", "summarization"],
  weaknesses: ["Limited free usage", "Academic papers only", "May oversimplify complex concepts"],
  complexity: "beginner"
},
{
  id: "paperpal",
  name: "Paperpal",
  url: "https://paperpal.com",
  shortDescription: "AI-powered academic writing assistant for research papers",
  supportType: ["research", "text"],
  category: ["research, knowledge, & learning platforms","writing & text generation"],
  aiDependency: "ai-only",
  price: "freemium",
  freeTierAccess: "somewhat-limited", // Limited edits and checks
  personaTypeMatch: ["academic-researcher", "professional-writer", "research-focused", "editor-focused", "perfectionist"],
  timePressure: "low",
  strengths: ["Academic writing focus", "Grammar and style", "Publication ready", "Research-specific", "technical-writing", "academic-writing", "proofreading"],
  weaknesses: ["Academic writing only", "Limited free tier", "Subscription for full features"],
  complexity: "beginner"
},
{
  id: "akiflow",
  name: "Akiflow",
  url: "https://akiflow.com",
  shortDescription: "Time-blocking calendar and task management for focused productivity",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "paid",
  freeTierAccess: "very-limited",
  personaTypeMatch: ["productivity-focused", "organized-planner", "focus-driven", "time-conscious"],
  timePressure: "medium",
  strengths: ["Time-blocking", "Calendar integration", "Task management", "Focus mode", "motivation", "planning"],
  weaknesses: ["Expensive subscription", "Learning curve", "Requires commitment to time-blocking", "learning-curve"],
  complexity: "intermediate"
},
{
  id: "microsoft-todo",
  name: "Microsoft To Do",
  url: "https://todo.microsoft.com",
  shortDescription: "Simple task management with Microsoft 365 integration",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "free",
  freeTierAccess: "robust",
  personaTypeMatch: ["productivity-focused", "quick-starter", "microsoft-user", "organized-planner"],
  timePressure: "low",
  strengths: ["Microsoft 365 integration", "Simple interface", "My Day feature", "motivation", "planning", "Clean UI"],
  weaknesses: ["Basic features", "Limited collaboration", "Microsoft ecosystem focused"],
  complexity: "beginner"
},
{
  id: "google-tasks",
  name: "Google Tasks",
  url: "https://tasks.google.com",
  shortDescription: "Lightweight task management integrated with Google Workspace",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "free",
  freeTierAccess: "robust",
  personaTypeMatch: ["productivity-focused", "quick-starter", "google-user", "organized-planner"],
  timePressure: "low",
  strengths: ["Google integration", "Minimal design", "Gmail integration", "motivation", "planning", "Clean UI"],
  weaknesses: ["Very basic features", "Limited functionality", "No advanced features"],
  complexity: "beginner"
},
{
  id: "clickup",
  name: "ClickUp",
  url: "https://clickup.com",
  shortDescription: "All-in-one productivity platform with tasks, docs, goals, and more",
  supportType: "research",
  category: "research, knowledge, & learning platforms",
  aiDependency: "ai-optional",
  price: "freemium",
  freeTierAccess: "robust",
  personaTypeMatch: ["productivity-focused", "organized-planner", "collaborative-worker"],
  timePressure: "medium",
  strengths: ["Highly customizable", "All-in-one workspace", "Multiple views", "note-taking", "motivation", "planning", "collaboration", "Clean UI"],
  weaknesses: ["Can be overwhelming", "Steep learning curve", "Feature overload", "learning-curve"],
  complexity: "intermediate"
},
{
  id: "notebooklm",
  name: "NotebookLM",
  url: "https://notebooklm.google.com",
  shortDescription: "AI research assistant that analyzes your documents, creates study guides, generates podcasts, and answers questions based on your sources",
  supportType: ["research"],
  category: ["research, knowledge, & learning platforms"],
  aiDependency: "ai-only",
  price: "free",
  freeTierAccess: "full",
  personaTypeMatch: ["summary-focused", "knowledge-manager", "conversational-learner", "note-taker", "audio-learner"],
  timePressure: "low",
  strengths: ["Source-grounded AI", "Audio Overview podcasts", "Study guide generation", "Multi-source synthesis", "Citation tracking", "Google Drive integration", "summarization", "note-taking"],
  weaknesses: ["Google account required", "Limited to uploaded sources", "No real-time web search", "Privacy concerns"],
  complexity: "beginner"
}

];

// Persona types that tools can match with
export const personaTypes = {
  "visual-learner": "Learns best through visual content and graphics",
  "analytical-thinker": "Enjoys breaking down problems systematically",
  "creative-expresser": "Focuses on artistic and creative output",
  "collaborative-worker": "Thrives in team environments",
  "quick-starter": "Prefers tools that work immediately",
  "detail-oriented": "Values precision and thoroughness",
  "brainstormer": "Enjoys ideation and concept development",
  "research-oriented": "Loves diving deep into topics",
  "conversational-learner": "Learns through dialogue and interaction",
  "safety-conscious": "Prioritizes secure and reliable tools",
  "organized-planner": "Likes structured workflows",
  "note-taker": "Focuses on documentation and organization",
  "productivity-focused": "Optimizes for efficiency",
  "perfectionist": "Wants polished, professional results",
  "professional-writer": "Serious about writing quality",
  "artistic": "Values aesthetic and creative expression",
  "visual-thinker": "Processes information visually",
  "rapid-prototyper": "Builds quick proof-of-concepts",
  "idea-tester": "Experiments with concepts rapidly",
  "code-curious": "Interested in learning programming",
  "systematic-builder": "Prefers methodical development",
  "patient-learner": "Willing to invest time in mastery",
  "technical-learner": "Enjoys complex technical tools",
  "open-source-advocate": "Values free and open tools",
  "web-focused": "Primarily works on web projects",
  "interactive-designer": "Creates engaging user experiences",
  "audio-focused": "Specializes in sound and audio",
  "music-lover": "Passionate about musical creation",
  "quick-creator": "Values fast content generation",
  "cutting-edge-adopter": "Embraces newest technologies",
  "video-creator": "Focuses on video content",
  "experimental": "Enjoys trying new approaches",
  "podcaster": "Creates audio content regularly",
  "content-creator": "Produces various media types",
  "efficiency-focused": "Optimizes workflow and time",
  "template-user": "Prefers starting with templates",
  "budget-conscious": "Prioritizes free or low-cost options",
  "microsoft-user": "Comfortable with Microsoft ecosystem",
  "google-user": "Comfortable with Google ecosystem",
  "adobe-user": "Comfortable with Adobe ecosystem",
  "presentation-focused": "Creates presentations regularly",
  "data-focused": "Works with data analysis and visualization",
  "story-teller": "Enjoys narrative and storytelling",
  "game-developer": "Creates games or interactive experiences",
  "3d-artist": "Works with 3D modeling and animation",
  "mobile-first-builder": "Focuses on mobile app development",
  "ai-enthusiast": "Excited about AI capabilities",
  "early-adopter": "Tries new technologies first"
};

// Support types for tools
export const supportTypes = {
  "visual": "Visual design, graphics, and imagery",
  "text": "Writing, editing, and text generation",
  "audio": "Sound, music, and voice processing", 
  "coding": "Programming and app development",
  "data": "Analysis, visualization, and databases",
  "3d": "3D modeling, spatial design, and simulations",
  "presentation": "Slides and presentation design",
  "video": "Video editing and production",
  "research": "Research and knowledge management"
}

